import { View, Text, StyleSheet, Modal, TouchableOpacity } from 'react-native';
import { Camera } from 'lucide-react-native';
import { useTheme } from '@/contexts/ThemeContext';

interface Props {
  visible: boolean;
  onRecord: () => void;
  onClose: () => void;
}

export default function VideoOptionsModal({ visible, onRecord, onClose }: Props) {
  const { theme } = useTheme();

  return (
    <Modal visible={visible} animationType="slide" transparent>
      <View style={styles.modalOverlay}>
        <View style={[styles.videoOptionsModal, { backgroundColor: theme.colors.surface }]}>
          <Text style={[styles.videoOptionsTitle, { color: theme.colors.text }]}>
            Add Video
          </Text>
          <Text style={[styles.videoOptionsSubtitle, { color: theme.colors.textSecondary }]}>
            Choose how to add your video
          </Text>

          <TouchableOpacity
            style={[
              styles.videoOptionButton,
              { backgroundColor: theme.colors.surfaceVariant, borderColor: theme.colors.accent },
            ]}
            onPress={onRecord}>
            <Camera size={24} color={theme.colors.accent} />
            <View style={styles.videoOptionTextContainer}>
              <Text style={[styles.videoOptionButtonText, { color: theme.colors.text }]}>
                Record Video
              </Text>
              <Text style={[styles.videoOptionDescription, { color: theme.colors.textSecondary }]}>
                Use camera to record
              </Text>
            </View>
          </TouchableOpacity>

          <Text style={{ color: theme.colors.textTertiary, fontSize: 12, textAlign: 'center', marginTop: 8 }}>
            Record your top set only • 10-15 seconds recommended
          </Text>

          <TouchableOpacity
            style={[styles.cancelButton, { backgroundColor: theme.colors.surfaceVariant }]}
            onPress={onClose}>
            <Text style={[styles.cancelButtonText, { color: theme.colors.textSecondary }]}>
              Cancel
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.8)',
    justifyContent: 'flex-end',
  },
  videoOptionsModal: {
    margin: 20,
    marginTop: 'auto',
    borderRadius: 2,
    padding: 24,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  videoOptionsTitle: {
    fontSize: 24,
    fontWeight: '900',
    marginBottom: 8,
  },
  videoOptionsSubtitle: {
    fontSize: 16,
    marginBottom: 24,
  },
  videoOptionButton: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
    borderRadius: 0,
    marginBottom: 12,
    borderWidth: 2,
    gap: 16,
  },
  videoOptionTextContainer: {
    flex: 1,
  },
  videoOptionButtonText: {
    fontSize: 16,
    fontWeight: '700',
    marginBottom: 4,
  },
  videoOptionDescription: {
    fontSize: 14,
  },
  cancelButton: {
    padding: 16,
    borderRadius: 0,
    alignItems: 'center',
    marginTop: 8,
  },
  cancelButtonText: {
    fontSize: 16,
    fontWeight: '600',
  },
});
